import { useEffect, useRef, useState } from "react";
import { RefreshCw, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const scriptsOf = (html) => [...html.matchAll(/<script[^>]+src="([^"]+)"/g)].map((m) => m[1]).filter((s) => /static\/js\/main\.|bundle\.js/.test(s)).sort().join("|");

export const applyUpdate = async () => {
  try {
    const regs = await navigator.serviceWorker?.getRegistrations?.() || [];
    await Promise.all(regs.map((r) => r.update().catch(() => null)));
    if (window.caches) { const keys = await caches.keys(); await Promise.all(keys.map((k) => caches.delete(k))); }
  } finally { window.location.reload(); }
};

export const UpdateBanner = () => {
  const [ready, setReady] = useState(false);
  const base = useRef(null);
  useEffect(() => {
    const check = async () => {
      try {
        const html = await (await fetch(`/?v=${Date.now()}`, { cache: "no-store" })).text();
        const s = scriptsOf(html);
        if (!s) return;
        if (base.current === null) base.current = scriptsOf(document.documentElement.outerHTML) || s;
        if (s !== base.current) setReady(true);
      } catch { /* offline */ }
    };
    check();
    const id = setInterval(check, 120000);
    const vis = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", vis);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", vis); };
  }, []);
  if (!ready) return null;
  return (
    <div className="fixed inset-x-3 bottom-20 z-[60] mx-auto flex max-w-md items-center gap-3 rounded-2xl bg-[#142F39] p-3 text-white shadow-2xl fade-up lg:bottom-6" role="status" data-testid="update-banner">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#8ce2b8]/20"><Sparkles className="h-4 w-4 text-[#8ce2b8]" /></span>
      <div className="min-w-0 flex-1 text-sm"><div className="font-extrabold">Nouvelle version disponible</div><div className="text-xs text-white/70">Mettez à jour pour profiter des dernières améliorations.</div></div>
      <Button size="sm" className="rounded-full bg-[#8ce2b8] font-bold text-[#142F39] hover:bg-[#a5ebc8]" onClick={applyUpdate} data-testid="update-apply"><RefreshCw className="mr-1 h-3.5 w-3.5" /> Mettre à jour</Button>
    </div>
  );
};
